import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import { Sidebar } from "./Sidebar";
import { Topbar } from "./Topbar";

export function AppLayout() {
  const [collapsed, setCollapsed] = useState(() => {
    try {
      return localStorage.getItem("crm_sidebar_collapsed") === "true";
    } catch {
      return false;
    }
  });

  const handleToggle = () => {
    setCollapsed((prev) => {
      const next = !prev;
      try {
        localStorage.setItem("crm_sidebar_collapsed", String(next));
      } catch {}
      return next;
    });
  };

  return (
    <div className="flex flex-col h-screen w-screen overflow-hidden bg-[#363636] text-foreground">
      {/* 1. Full-width Connected Dark Topbar (#363636) */}
      <Topbar collapsed={collapsed} onToggleSidebar={handleToggle} />

      {/* 2. Lower Body: Dark Sidebar (#363636) + Connected White Canvas (#ffffff) */}
      <div className="flex-1 flex min-h-0 w-full overflow-hidden bg-[#363636]">
        <Sidebar collapsed={collapsed} onToggle={handleToggle} />
        
        {/* HubSpot-style Connected Canvas (#efefef) with rounded top-left corner */}
        <div className="flex-1 min-h-0 flex flex-col bg-[#efefef] rounded-tl-[20px] shadow-sm overflow-hidden">
          <main className="flex-1 overflow-y-auto min-h-0 p-3 sm:p-4 md:p-5 bg-[#efefef]">
            {/* THE BIG WHITE WORKSPACE CARD (#ffffff) */}
            <div className="w-full min-h-full bg-[#ffffff] rounded-2xl border border-slate-200/80 shadow-xs p-5 md:p-6 flex flex-col">
              <Outlet />
            </div>
          </main>
        </div>
      </div>
    </div>
  );
}
